import {
  GET_CART_OBJECT_REQUESTING,
  GET_CART_SUCCESS,
  RESET_CART_ISFETCHING,
  SIDE_CART_VISIBLE,
  SIDE_CART_NOT_VISIBLE,
  CART_IS_ITEM_BEING_ADDED,
  AUTH_FULLSTEAM_WALLET_SUCCESS,
  AUTH_FULLSTEAM_WALLET_REQUESTING,
  CHARGE_FULLSTEAM_WALLET_REQUESTING,
  CHARGE_FULLSTEAM_WALLET_SUCCESS,
  RESET_FULLSTEAM_WALLET_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false,
  isSideCartVisible: false,
  skuBeingAdded: null,
  screenReaderMessage: null,
  cartUpdateMessage: null,
  fullSteamAuth: null,
  fullSteamResponse: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIDE_CART_VISIBLE: {
      return {
        ...state,
        isSideCartVisible: true
      };
    }
    case SIDE_CART_NOT_VISIBLE: {
      return {
        ...state,
        isSideCartVisible: false
      };
    }
    case RESET_CART_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false,
        skuBeingAdded: null
      };
    }
    case CART_IS_ITEM_BEING_ADDED: {
      return {
        ...state,
        skuBeingAdded: action.skuBeingAdded
      };
    }
    case GET_CART_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }

    case AUTH_FULLSTEAM_WALLET_REQUESTING: {
      return {
        ...state,
        fullSteamAuth: { isFetching: true }
      };
    }

    case AUTH_FULLSTEAM_WALLET_SUCCESS: {
      const data = action.payload;

      const newData = {
        ...data,
        isFetching: false
      };

      return {
        ...state,
        fullSteamAuth: newData
      };
    }

    case CHARGE_FULLSTEAM_WALLET_REQUESTING: {
      return {
        ...state,
        fullSteamResponse: { isFetching: true }
      };
    }

    case RESET_FULLSTEAM_WALLET_ISFETCHING: {
      return {
        ...state,
        fullSteamResponse: { isFetching: false }
      };
    }

    case CHARGE_FULLSTEAM_WALLET_SUCCESS: {
      const data = action.payload;

      const newData = {
        ...data,
        isFetching: false
      };

      return {
        ...state,
        fullSteamResponse: newData
      };
    }

    case GET_CART_SUCCESS: {
      return {
        ...state,
        data: action.cart,
        cartUpdateMessage: action.cartUpdateMessage,
        isObjectFetching: false,
        skuBeingAdded: null
      };
    }
    default:
      return state;
  }
};

export default reducer;
